// officeInvite.reducer.js
import { officeInviteConstants as C } from "../actions/constants";

const initialState = {
    invitesByOffice: {},
    publicInvite: null,
    lastCreatedInvite: null,
    lastInviteUrl: "",
    userExists: false,
    loading: false,
    actionLoading: false,
    publicLoading: false,
    error: null,
    message: "",
};

const getId = (value) => String(value?._id || value?.id || value || "");

const upsertInvite = (list = [], invite) => {
    if (!invite) return list;

    const id = getId(invite);
    const exists = list.some((item) => getId(item) === id);

    if (!exists) return [invite, ...list];

    return list.map((item) => (getId(item) === id ? invite : item));
};

export default function officeInviteReducer(state = initialState, action) {
    switch (action.type) {
        case C.CLEAR_OFFICE_INVITE_ERROR:
            return {
                ...state,
                error: null,
                message: "",
            };

        case C.CLEAR_PUBLIC_OFFICE_INVITE:
            return {
                ...state,
                publicInvite: null,
                error: null,
                message: "",
            };

        case C.GET_OFFICE_INVITES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case C.CREATE_OFFICE_INVITE_REQUEST:
        case C.CANCEL_OFFICE_INVITE_REQUEST:
        case C.ACCEPT_OFFICE_INVITE_REQUEST:
        case C.DECLINE_OFFICE_INVITE_REQUEST:
            return {
                ...state,
                actionLoading: true,
                error: null,
                message: "",
            };

        case C.GET_OFFICE_INVITE_BY_TOKEN_REQUEST:
            return {
                ...state,
                publicLoading: true,
                error: null,
                message: "",
            };

        case C.GET_OFFICE_INVITES_SUCCESS:
            return {
                ...state,
                loading: false,
                invitesByOffice: {
                    ...state.invitesByOffice,
                    [action.payload.officeId]: action.payload.invites || [],
                },
                error: null,
            };

        case C.CREATE_OFFICE_INVITE_SUCCESS: {
            const officeId = action.payload.officeId;
            const currentList = state.invitesByOffice[officeId] || [];

            return {
                ...state,
                actionLoading: false,
                invitesByOffice: {
                    ...state.invitesByOffice,
                    [officeId]: upsertInvite(currentList, action.payload.invite),
                },
                lastCreatedInvite: action.payload.invite || null,
                lastInviteUrl: action.payload.inviteUrl || "",
                userExists: !!action.payload.userExists,
                message: action.payload.message || "Приглашение создано",
                error: null,
            };
        }

        case C.CANCEL_OFFICE_INVITE_SUCCESS: {
            const officeId = action.payload.officeId;
            const currentList = state.invitesByOffice[officeId] || [];

            return {
                ...state,
                actionLoading: false,
                invitesByOffice: {
                    ...state.invitesByOffice,
                    [officeId]: upsertInvite(currentList, action.payload.invite),
                },
                message: "Приглашение отменено",
                error: null,
            };
        }

        case C.GET_OFFICE_INVITE_BY_TOKEN_SUCCESS:
            return {
                ...state,
                publicLoading: false,
                publicInvite: action.payload.invite || null,
                error: null,
            };

        case C.ACCEPT_OFFICE_INVITE_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                publicInvite: action.payload.invite || state.publicInvite,
                message: action.payload.message || "Приглашение принято",
                error: null,
            };

        case C.DECLINE_OFFICE_INVITE_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                publicInvite: action.payload.invite || state.publicInvite,
                message: action.payload.message || "Приглашение отклонено",
                error: null,
            };

        case C.GET_OFFICE_INVITES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки приглашений",
            };

        case C.GET_OFFICE_INVITE_BY_TOKEN_FAILURE:
            return {
                ...state,
                publicLoading: false,
                error: action.payload?.error || "Ошибка загрузки приглашения",
            };

        case C.CREATE_OFFICE_INVITE_FAILURE:
        case C.CANCEL_OFFICE_INVITE_FAILURE:
        case C.ACCEPT_OFFICE_INVITE_FAILURE:
        case C.DECLINE_OFFICE_INVITE_FAILURE:
            return {
                ...state,
                actionLoading: false,
                error: action.payload?.error || "Ошибка операции с приглашением",
            };

        default:
            return state;
    }
}